/**
  * 数据分析
*/
import axios from '../request';
export default{
  /**
   * 生产统计对比
  */

  // 查询钢筋笼生产实际对比
  searchSteelProducePlan: params =>
    axios.post('/m/steelProduce/monthProduce', params),
  // 查询管片生产实际对比
  searchPipeComparePlan: params =>
    axios.post('m/pipeInfo/pipeComparePlan', params),
  // 查询管片月环比
  searchPipeMonthPlan: params =>
    axios.post('m/pipeInfo/pipeMonth', params),
  
  /**
   * 物资消耗统计中的（原材料消耗）
   */
  // 查询原料消耗
  searchMaterialCost: params =>
    axios.post('/materials/mixingstationstorage/RsbStat', params),

  /**
   * 物资消耗统计中的（钢筋消耗）
   */
  //查询钢筋消耗
  searchRebarCost: params =>
    axios.post('/materials/record/recordStatistics', params),
  //导出按钮
  exportRebarCost: (params) =>
    axios({
      method: 'post',
      url: '/materials/record/recordStatisticsExcel',
      responseType: 'blob',
      data: params
    }),
  //查询钢筋数据统计
  searchAnalyse: params =>
    axios.post('/materials/record/recordSum', params),
  

  /**
   * 物资消耗统计中的（辅材消耗）
   */
  //查询辅材消耗
  searchAuxilliaryCost: params =>
    axios.post('/materials/assistRecord/assistStatistics', params),
  //导出按钮
  exportAuxilliaryCost: (params) =>
    axios({
      method: 'post',
      url: '/materials/assistRecord/assistStatisticsExcel',
      responseType: 'blob',
      data: params
    }),
  //物品名称下拉
  auxilliaryCostList: params =>
    axios.get('/materials/assistRecord/assistRecordPull', {params}),

  /**
   * 生产发运统计
   */
  //查询数据统计
  searchDataLists: params =>
    axios.post('/materials/pipeOut/pipeOutShippingSum', params),
  //运输量排行
  searchRanksForward: params =>
    axios.post('/materials/pipeOut/pipeOutRanking', params),
}